import { Component, OnInit } from '@angular/core';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { OzonProductProfileComponent } from 'src/app/components/dialog/integrations/ozon/ozon-product-profile/ozon-product-profile.component';
import { OzonProductList, PaginationPageEvent, Res } from 'src/app/models';
import { DialogModalService, LanguageService, NotificationService } from 'src/app/services';
import { ApiOzonProductListService } from 'src/app/services/integrations/ozon/api-ozon-product-list.service';

@Component({
  selector: 'app-ozon-product-list',
  templateUrl: './ozon-product-list.component.html',
  styleUrls: ['./ozon-product-list.component.css']
})
export class OzonProductListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  listData: OzonProductList[] = [];
  paginationInput: any;
  paginationOutput: PaginationPageEvent;
  listParams: any;
  multiple:boolean = true;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiOzonService: ApiOzonProductListService,
    private dialogModal: DialogModalService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.listData = [];

    this.setListParams();

    this.apiOzonService.getList(this.listParams).subscribe((response: Res) => { console.log('[RESPONSE] getPrices: ', response);

      if (response) {

        if (response.result != null) {

          this.listData = response.result.list;

          this.paginationInput = {
            count:         response.result.count,
            numberOfPages: response.result.numberOfPages,
            currentPage:   this.listParams.pageNumber,
            size:          this.listParams.countOnPage
          }
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
    error => {
      this.progressRef.complete();
      this.loading = false;
    });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        org_id: null
      },
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  /**
   * 
   * @param event PaginationPageEvent
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }


   /**
   * 
   */
    getProfile(id: string) {

      let data = {
        id: id
      }
  
      this.dialogModal.open(data, OzonProductProfileComponent).then(
        (result) => {
  
          if (result) {
  
          }
        },
        () => { console.log('Rejected!'); }
      );
    }


  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.listData[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.listData.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.listData.length == 0) return false;

    return this.listData.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.listData.length;
    let pc = this.listData.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.listData.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }

}
